import React, {useEffect, useState} from 'react';
import './ConnectionLostOverlay.css';

// Пока идут попытки автопереподключения в матче (см. LobbyPage), обратный
// отсчет до следующей попытки считаем локально от момента получения
// reconnectStatus — сервер присылает только фиксированную задержку попытки,
// не тикающий таймер
function useCountdownMs(targetMs) {
  const [remainingMs, setRemainingMs] = useState(targetMs);

  useEffect(() => {
    setRemainingMs(targetMs);
    if (!targetMs) return;
    const startedAt = Date.now();
    const intervalId = setInterval(() => {
      setRemainingMs(Math.max(0, targetMs - (Date.now() - startedAt)));
    }, 200);
    return () => clearInterval(intervalId);
  }, [targetMs]);

  return remainingMs;
}

function ConnectionLostOverlay({reconnectStatus, isSuperseded}) {
  const remainingMs = useCountdownMs(reconnectStatus?.retryInMs ?? 0);

  const handleReload = () => {
    sessionStorage.setItem('reconnectToLobbyList', '1');
    window.__skipBeforeUnload = true;
    window.location.reload();
  };

  // isSuperseded — тот же игрок зашел в этот же матч с другого устройства
  // (см. SESSION_SUPERSEDED в LobbyPage): это не обрыв связи, поэтому
  // отдельные заголовок/текст, но тот же оверлей и та же кнопка перезагрузки
  // isWaitingForServer — сокет еще открыт, но сервер молчит дольше нормы
  // (см. сторож тишины в LobbyPage): переподключение еще не начиналось, и
  // обещать «попытка N из M» рано — но игрок уже должен понимать, почему поле
  // замерло
  const isWaitingForServer = Boolean(reconnectStatus?.isWaitingForServer);

  const title = isSuperseded
    ? 'Вход с другого устройства'
    : isWaitingForServer ? 'Сервер не отвечает'
      : reconnectStatus ? 'Переподключение' : 'Соединение разорвано';

  return (
    <div className="connection-lost-overlay">
      <h2 className="connection-lost-title">
        {title}
      </h2>
      <p className="connection-lost-text">
        {isSuperseded ? (
          'Вы вошли в игру с другого устройства. Если хотите продолжить играть на этом устройстве — перезагрузите страницу.'
        ) : isWaitingForServer ? (
          'Связь с сервером пропала: события матча не приходят. Ждем восстановления, поле обновится само.'
        ) : reconnectStatus ? (
          <>
            Похоже, связь с сервером прервалась. Пробуем восстановить соединение
            (попытка {reconnectStatus.attempt} из {reconnectStatus.maxAttempts})
            {remainingMs > 0 && `, следующая попытка через ${Math.ceil(remainingMs / 1000)} с`}.
          </>
        ) : (
          'Похоже, связь с сервером прервалась. Нажмите кнопку ниже, чтобы переподключиться.'
        )}
      </p>
      <button className="connection-lost-button" onClick={handleReload}>
        Перезагрузить страницу
      </button>
    </div>
  );
}

export default ConnectionLostOverlay;
